import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[appOnlyNumbers]',
    standalone: true
})
export class OnlyNumbersDirective {

  constructor( private elementRef: ElementRef ) { }
  @HostListener('input', ['$event'])
  onChangeInput( event: any ): void {
    const numbersOnly = /[^0-9]*/g

    const initValue: string = this.elementRef.nativeElement.value;
    const filteredValue = initValue.replace(numbersOnly, '');

    if (initValue !== filteredValue) {
      this.elementRef.nativeElement.value = filteredValue;
      this.elementRef.nativeElement.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
}
